<script lang="ts">
    import { onMount } from "svelte"
    import CookieSet from "./cookieSet.svelte"
    $: iframeTitle = "testrest"

    let setHeight = (element) => {
        element.style.height = (element.offsetWidth / 16) * 9 + "px"
    }
    //t
</script>

<CookieSet cookieName="{'googleMaps'}" textPosition="{'unten'}" background="{'rgba(44, 44, 44, 0.4)'}">
    <iframe
        title="Google Maps"
        use:setHeight
        id="iframe"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2628.728080514621!2d9.152879676964922!3d48.78708130572151!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4799db173dfa334b%3A0x7fe6b3c1d5d8d346!2sHauptmannsreute%2044%2C%2070192%20Stuttgart!5e0!3m2!1sde!2sde!4v1690130673148!5m2!1sde!2sde"
        style="border:0;"
        allowfullscreen="{true}"
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"></iframe>
</CookieSet>

<style>
    iframe {
        width: 100%;
        max-width: 100%;
        border: 0;
    }
</style>
